import { default as _useDesktopMediaQuery } from "hooks/useDesktopMediaQuery";

export const useDesktopMediaQuery = _useDesktopMediaQuery;
